import script from "./BrievenSection.vue?vue&type=script&setup=true&lang=js"
export * from "./BrievenSection.vue?vue&type=script&setup=true&lang=js"

import "./BrievenSection.vue?vue&type=style&index=0&id=54aa44fb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54aa44fb"]])

export default __exports__